module.exports = __webpack_public_path__ + "static/media/galeryVinyl2.1731b056.jpg";